/* eslint-disable no-nested-ternary */
import React from 'react';
import Particles from 'react-particles-js';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { getBrowserLanguage } from '../../utils';
import ErrorPageBg from '../../images/error-page-bg.png';
import logo from '../../images/logo-horizontal-white.png';
import logoIcon from '../../images/logo-horizontal.png';
import './Expire.scss';

const ExpireEngagement = ({ pageProps, logoUrl, loadingLogo }) => {
    const { t } = useTranslation();
    const browserLanguage = getBrowserLanguage();
    const defaultMessage = browserLanguage === '日本語' ? '問題が発生しました。' : 'Something went wrong';
    return (
        <div id='root'>
            <Particles style={ { position: 'absolute' } } />
            <img
                src={ ErrorPageBg }
                alt='error-page-bg'
                style={ {
                    position: 'absolute', height: '100%', width: '100%', top: 0
                } } />
            <div className='maintenance'>
                <h1 className='maintenance-header'>
                    { pageProps.title ? t(pageProps.title) : pageProps.title }
                </h1>
                <p className='maintenance-body'>
                    {
                        pageProps.message ? (
                            React.isValidElement(pageProps.message) ?
                                pageProps.message :
                                t(pageProps.message)
                        ) : defaultMessage
                    }
                    {
                        pageProps.renderLink && pageProps.renderLink()
                    }
                </p>
                <a href='https://my.attuned.ai' className='logo-container'>
                    { loadingLogo ? (
                        <React.Fragment />
                    ) : (logoUrl ? (
                        <img src={ logoUrl } alt='logo-icon' />
                    ) : (
                        <React.Fragment>
                            <img src={ logoIcon } alt='logo-icon' />
                            <img src={ logo } alt='flow logo' />
                        </React.Fragment>
                    )) }
                </a>
            </div>
        </div>
    );
};

ExpireEngagement.propTypes = {
    pageProps: PropTypes.object,
    logoUrl: PropTypes.string,
    loadingLogo: PropTypes.bool
};

ExpireEngagement.defaultProps = {
    pageProps: {},
    logoUrl: null,
    loadingLogo: true
};

const mapStateToProps = state => ({
    pageProps: state.pageReducer.get('pageProps'),
    logoUrl: state.logoReducer.get('logoUrl'),
    loadingLogo: state.logoReducer.get('loadingLogo')
});

export default connect(mapStateToProps, null)(ExpireEngagement);
